import moment from 'moment';

export function until(promiseOrPromiseList) {
  if (!promiseOrPromiseList) {
    console.error('no promise passed.', promiseOrPromiseList);
    return Promise.reject([new Error('Unknown Error')]);
  }
  //array of promises
  if (Array.isArray(promiseOrPromiseList)) {
    return Promise.all(promiseOrPromiseList)
      .then((data) => {
        return [null, data];
      })
      .catch((err) => {
        return [err, promiseOrPromiseList.map(() => undefined)];
      });
  }
  //single promise call
  return promiseOrPromiseList
    .then((data) => {
      return [null, data];
    })
    .catch((err) => {
      return [err];
    });
}

export const getFullName = (firstName, lastName) =>
  `${firstName || ''} ${lastName || ''}`.trim();

export function uniqueItems(objArray, key) {
  if (!objArray || !key) {
    console.error('no args', objArray, key);
    return objArray;
  }
  return objArray.reduce((result, obj) => {
    if (result.find((o) => o[key] == obj[key])) {
      return result;
    }
    return [...result, obj];
  }, []);
}

export function string_to_slug(str = '', separator = '-') {
  if (!str) return str;
  str = str.trim();
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  const from = 'åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;';
  const to = 'aaaaaaeeeeiiiioooouuuunc------';

  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  return str
    .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-') // collapse dashes
    .replace(/^-+/, '') // trim - from start of text
    .replace(/-+$/, '') // trim - from end of text
    .replace(/-/g, separator);
}

export function slugToFormattedStr(slug = '', separator = '_') {
  if (!slug) return slug;
  slug = slug.trim();
  let words = slug.split(separator);
  words = words.map((w) => {
    return w[0].toUpperCase() + w.substr(1);
  });
  return words.join(' ');
}

/**
 *@template T
 * @param {T} obj
 * @returns {T} obj
 */
export function cloneObject(obj) {
  var clone = Array.isArray(obj) ? [] : {};
  for (var i in obj) {
    if (obj[i] != null && typeof obj[i] == 'object')
      clone[i] = cloneObject(obj[i]);
    else clone[i] = obj[i];
  }
  return clone;
}

export const lowercaseKeys = (obj) =>
  Object.keys(obj).reduce((acc, key) => {
    acc[key.toLowerCase()] = obj[key];
    return acc;
  }, {});

/**
 * @description adds a unique_id key if the objects in array doesnot have id key.
 * @param {Object[]} listOfObjects
 */
export function addIdKey(listOfObjects, keyName = 'id') {
  return (listOfObjects || []).map((i, idx) => ({
    ...i,
    [keyName]: i[keyName] || new Date().getTime() + '' + idx + Math.random(),
  }));
}

/**
 * https://stackoverflow.com/a/49860927/7314900
 * @param {HTMLElement|Element} element
 * @param {("top"|"bottom"|"left"|"right")} direction
 * todo: direction should be calculated basing on its position and offset inparent.
 */
export function scrollToTargetWithOffset(element, direction) {
  var headerOffset = 30;
  var elementPosition = element.getBoundingClientRect()[direction];
  var offsetPosition = ['top', 'left'].includes(direction)
    ? elementPosition - headerOffset
    : elementPosition + headerOffset;
  element.parentElement.scrollTo({
    [direction]: offsetPosition,
    behavior: 'smooth',
  });
}

export function sleep(ms = 500) {
  return new Promise((resolve) => {
    let wait = setTimeout(() => {
      clearTimeout(wait);
      resolve('waited for atleast ' + ms + ' milliseconds');
    }, ms);
  });
}

export function downloadFileFromData(binaryData, fileName) {
  const url = window.URL.createObjectURL(new Blob([binaryData]));
  const link = document.createElement('a');
  link.href = url;

  //todo: set proper name
  link.setAttribute('download', 'Resume.zip');
  document.body.appendChild(link);
  link.click();
  link.remove();
}

/*
  https://stackoverflow.com/a/61613914/7314900
*/
export function reorder(array, sourceIndex, destinationIndex) {
  const smallerIndex = Math.min(sourceIndex, destinationIndex);
  const largerIndex = Math.max(sourceIndex, destinationIndex);

  return [
    ...array.slice(0, smallerIndex),
    ...(sourceIndex < destinationIndex
      ? array.slice(smallerIndex + 1, largerIndex + 1)
      : []),
    array[sourceIndex],
    ...(sourceIndex > destinationIndex
      ? array.slice(smallerIndex, largerIndex)
      : []),
    ...array.slice(largerIndex + 1),
  ];
}

export function getUniqueNumber() {
  const u = (window.__AWL_UNIQUE_NUMBER__ =
    (window.__AWL_UNIQUE_NUMBER__ || 0) + 1);
  return u;
}

export function toLabelValue(d) {
  d = d || {};
  return {
    value: d.id || d.value,
    label: d.name || d.label || d.timezone,
  };
}

export function mapToLabelValue(d) {
  if (!Array.isArray(d)) {
    // console.error('mapToLabelValue :not an array', d);
    return [];
  }
  return d.map(toLabelValue);
}

export function getNestedValue(obj, path) {
  if (!obj) {
    return null;
  }
  if (!path) {
    return obj;
  }
  const properties = typeof path == 'string' ? path.split('.') : path;
  return getNestedValue(obj[properties.shift()], properties.join('.'));
}

/**
 * https://stackoverflow.com/a/46008856/7314900
 * Dynamically sets a deeply nested value in an object.
 * Optionally "bores" a path to it if its undefined.
 * @param {object} params
 * @property {!object} params.obj  - The object which contains the value you want to change/set.
 * @property {!array|string} params.path  - The array representation of path to the value you want to change/set.
 * @property {!mixed} params.value - The value you want to set it to.
 * @property {boolean} params.setrecursively - If true, will set value of non-existing path as well.
 * @property {boolean} params.returnObj - to return or not to return
 * @property {boolean} params.modifyOriginal - should modify original object or, clone object before changing
 */
export function setDeep({
  obj,
  path,
  value,
  setrecursively = false,
  returnObj = true,
  modifyOriginal = false,
}) {
  if (!modifyOriginal) {
    obj = cloneObject(obj);
  }
  if (typeof path == 'string') path = path.split('.');
  path.reduce((a, b, level) => {
    if (
      setrecursively &&
      typeof a[b] === 'undefined' &&
      level !== path.length - 1
    ) {
      if (!isNaN(path[level + 1])) {
        a[b] = [];
      } else {
        a[b] = {};
      }
      return a[b];
    }
    if (level === path.length - 1) {
      a[b] = value;
      return value;
    }
    return a[b];
  }, obj);
  if (returnObj) {
    return obj;
  }
}

// https://stackoverflow.com/a/59590002/7314900
export function camelToTitleCase(str) {
  return str
    .replace(/[0-9]{2,}/g, (match) => ` ${match} `)
    .replace(/[^A-Z0-9][A-Z]/g, (match) => `${match[0]} ${match[1]}`)
    .replace(
      /[A-Z][A-Z][^A-Z0-9]/g,
      (match) => `${match[0]} ${match[1]}${match[2]}`,
    )
    .replace(/[ ]{2,}/g, () => ' ')
    .replace(/\s./g, (match) => match.toUpperCase())
    .replace(/^./, (match) => match.toUpperCase())
    .trim();
}

/**
 *
 * @param {string} str
 * @returns
 */

export function toTitleCase(str) {
  return str[0].toUpperCase() + str.substring(1).toLowerCase();
}

/**
 * deep objectCompare
 * @link https://gist.github.com/nicbell/6081098
 */
export function objectCompare(obj1, obj2) {
  if (!obj1 || !obj2) return false;
  //Loop through properties in object 1
  for (var p in obj1) {
    //Check property exists on both objects
    if (
      Object.prototype.hasOwnProperty.call(obj1, p) !==
      Object.prototype.hasOwnProperty.call(obj2, p)
    )
      return false;

    switch (typeof obj1[p]) {
      //Deep compare objects
      case 'object':
        if (!objectCompare(obj1[p], obj2[p])) return false;
        break;
      //Compare function code
      case 'function':
        if (
          typeof obj2[p] == 'undefined' ||
          obj1[p].toString() != obj2[p].toString()
        )
          return false;
        break;
      //Compare values
      default:
        if (obj1[p] != obj2[p]) return false;
    }
  }

  //Check object 2 for any extra properties
  for (var v in obj2) {
    if (typeof obj1[v] == 'undefined') return false;
  }
  return true;
}

export function getKeyValuePairOfObj(obj) {
  let arr = [];
  for (const [key, value] of Object.entries(obj)) {
    arr.push({
      label: value,
      value: key,
    });
  }
  return arr;
}

/**
 *
 * @param {string} date date in dateString orr YYYY-MM-DD format
 * @param {string} time time in 24hour format HH:mm
 * @returns {string} isoString
 */
export function createIsoString(date, time) {
  if (!date) throw new Error('date not given');
  const d = new Date(date);
  if (time) {
    d.setHours(time.split(':')[0]);
    d.setMinutes(time.split(':')[1]);
  }
  return d.toISOString();
}

export function createDatetimeString(date, time) {
  if (!date) throw new Error('date not given');
  const d = new Date(date);
  if (time) {
    d.setHours(time.split(':')[0]);
    d.setMinutes(time.split(':')[1]);
  }
  return (
    d.getFullYear() +
    '-' +
    (d.getMonth() + 1) +
    '-' +
    d.getDate() +
    ' ' +
    d.getHours() +
    ':' +
    d.getMinutes()
  );
}

//https://stackoverflow.com/questions/5072136/javascript-filter-for-objects
// filter by specific key
export function filterkey(object, ...keys) {
  return keys.reduce((result, key) => ({...result, [key]: object[key]}), {});
}

export function placeCaretAtEnd(el) {
  el.focus();
  if (
    typeof window.getSelection != 'undefined' &&
    typeof document.createRange != 'undefined'
  ) {
    var range = document.createRange();
    range.selectNodeContents(el);
    range.collapse(false);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  } else if (typeof document.body.createTextRange != 'undefined') {
    var textRange = document.body.createTextRange();
    textRange.moveToElementText(el);
    textRange.collapse(false);
    textRange.select();
  }
}
export function ellipsize(str = '', maxLen = 50) {
  if (!isNaN(str)) str = str + ''; //catch numbers
  if (!str) str = ''; //catch null or undefined

  return str.length > maxLen ? str.substring(0, maxLen) + '...' : str;
}

/**
 * Gets keyboard-focusable elements within a specified element
 * @param {HTMLElement} [element=document] element
 * @returns {Array}
 */
export function getKeyboardFocusableElements(element = document) {
  return [
    ...element.querySelectorAll(
      'a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])',
    ),
  ].filter(
    (el) => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'),
  );
}

// // https://www.30secondsofcode.org/js/s/debounce
// export const debounce = (fn, ms = 0) => {
//   let timeoutId;
//   return function (...args) {
//     console.log('clearing',timeoutId)
//     clearTimeout(timeoutId);
//     timeoutId = setTimeout(() => fn.apply(this, args), ms);
//   };
// };

// https://www.joshwcomeau.com/snippets/javascript/debounce/
export const debounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    // console.log('clearing', timeoutId);
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
    }, wait);
  };
};

/**
 * @description focuses next focusable element in document.
 * @param {Element} currentFocusedEl
 * @param {HTMLElement} [parent]
 */
export function focusNextElement(currentFocusedEl, parent) {
  const elements = getKeyboardFocusableElements(parent);
  let searchInputIdx = elements.findIndex((el) => el === currentFocusedEl);
  if (searchInputIdx >= 0) {
    if (searchInputIdx == elements.length - 1) searchInputIdx = 0;
    elements[searchInputIdx + 1].focus();
  }
}

/**
 * @description focuses next focusable element in document.
 * @param {Element} currentFocusedEl
 * @param {HTMLElement} [parent]
 */
export function focusPrevElement(currentFocusedEl, parent) {
  const elements = getKeyboardFocusableElements(parent);
  let searchInputIdx = elements.findIndex((el) => el === currentFocusedEl);
  if (searchInputIdx >= 0) {
    if (searchInputIdx == 0) searchInputIdx = elements.length;
    elements[searchInputIdx - 1].focus();
  }
}

export function normalizeArray(arr, key) {
  let noKey = false;
  if (!key) {
    if (typeof arr[0] != 'object')
      noKey = true; //this is array of ids or strings
    else throw 'Key is not passed to normalizeArray';
  }
  return (arr ?? []).reduce((acc, i) => {
    if (!i) {
      console.error('no item in array', arr, i);
      return acc;
    }
    acc[noKey ? i : i[key]] = i;
    return acc;
  }, {});
}

/**
 *
 * @param {unknown[]} originalArray
 * @param {number} index
 * @param {unknown} newItem
 * @returns {unknown[]}
 */
export const insertAndReturn = (originalArray, index, newItem) => [
  ...originalArray.slice(0, index),
  newItem,
  ...originalArray.slice(index),
];
/**
 *
 * @param {any[]} from
 * @param {any[]} toRemove
 * @returns
 */
export function arraySubtract(from, toRemove) {
  if (!from || !toRemove) {
    console.error('non arrays - ', from, toRemove);
    return [];
  }
  toRemove.forEach((i) => {
    from = from.filter((f) => f !== i);
  });
  return from;
}

export function convert(str) {
  var date = new Date(str),
    mnth = ('0' + (date.getMonth() + 1)).slice(-2),
    day = ('0' + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join('-');
}
export const randomCharString = function (length) {
  let text = '';
  const possible =
    'ABCDEFGHIJKLMNOPQRSTUVWXYYZabcdefghijklmnopqrstuvwxyyz0123456789';
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};

export function randomNumberString(length) {
  let text = '';
  const possible = '0123456789';
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

/**
 * @link {https://stackoverflow.com/a/51963365}
 * @param {KeyBoardEvent} event
 * @description add this to type="number" inputs, since firefox doesnot support number inputs
 */
export function handleNumberInputKeyDown(event) {
  const keyCode = event.keyCode;
  // console.log(event.keyCode)
  const allowedKeys = [8, 37, 38, 40, 9, 39, 46, 188 /*comma*/, 190 /*dot*/];
  const isAllowed =
    (keyCode >= 48 && keyCode <= 57) ||
    (keyCode >= 96 && keyCode <= 105) ||
    (event.ctrlKey && keyCode === 86) /*ctrl+v*/ ||
    allowedKeys.includes(keyCode);
  if (!isAllowed) {
    // console.log(event.keyCode,'preventing')
    event.preventDefault();
  }
}

export const isFilterEmpty = (filters) => {
  return Object.keys(filters).some(
    (filterKey) => filters[filterKey].length > 0,
  );
};

export async function Sleep(ms) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(ms);
    }, ms);
  });
}

//todo: not tested
export async function waitUntil(fn) {
  let done = false;
  if (!fn()) {
    // console.log('hmm! not!');
    await Sleep(200);
    !done && waitUntil(fn);
  } else {
    done = true;
  }
}

export const changeUrlPath = (url, options) => {
  return window.history.replaceState(
    null,
    options?.title || document.title,
    url,
  );
};

export function timeStringToFloat(str) {
  let time = str.toString().replace(/ /g, '');
  var hoursMinutes = time.split(/[.:]/);
  var hours = parseInt(hoursMinutes[0], 10);
  var minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
  let value = (hours + minutes / 60).toFixed(2);
  return 1 * value;
}

export function floatToHoursMinutes(floatNumber) {
  // Extracting hours
  var hours = Math.floor(floatNumber);

  // Extracting minutes
  var minutesFloat = (floatNumber - hours) * 60;
  var minutes = Math.round(minutesFloat);

  // Formatting the result
  var result = hours < 10 ? `0${hours}` : hours;
  result += `:${minutes < 10 ? `0${minutes}` : minutes}`;

  return result;
}

export function decimalStringToTime(str) {
  var decimalTimeString = str.toString();
  var decimalTime = parseFloat(decimalTimeString);
  decimalTime = decimalTime * 60 * 60;
  var hours = Math.floor(decimalTime / (60 * 60));
  decimalTime = decimalTime - hours * 60 * 60;
  var minutes = Math.floor(decimalTime / 60);
  decimalTime = decimalTime - minutes * 60;
  if (hours < 10) {
    hours = '0' + hours;
  }
  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  return hours + ':' + minutes;
}

export function timeConvert(h, m) {
  var num = h * 60 + m;
  var hours = num / 60;
  var rhours = Math.floor(hours);
  var minutes = (hours - rhours) * 60;
  var rminutes = Math.round(minutes);
  return {
    rhours,
    rminutes,
  };
}

export function enumerateDaysBetweenDates(startDate, endDate) {
  let date = [];
  while (moment(startDate) <= moment(endDate)) {
    date.push(moment(startDate).format('YYYY-MM-DD'));
    startDate = moment(startDate).add(1, 'days').format('YYYY-MM-DD');
  }
  return date;
}

//columns sorting in table, if Array
export const sortArrayItems = (a, b, order) => {
  const left = (a || []).map((item) => item?.name);
  const right = (b || []).map((item) => item?.name);
  if (order === 'asc') return left.join().localeCompare(right.join());
  else return right.join().localeCompare(left.join());
};

//sortingList for dropdown(will work only if the key is name and label)
export const sortArrayList = (list = []) =>
  list.sort((a, b) => {
    if (a.label) {
      return (a?.label || '').toLowerCase() > (b?.label || '').toLowerCase()
        ? 1
        : -1;
    } else {
      return (a?.name || '').toLowerCase() > (b?.name || '').toLowerCase()
        ? 1
        : -1;
    }
  });

export function extractFileNameFromHeaders(res) {
  return res.headers['content-disposition'].match(/filename="(.+)"/)?.[1] || '';
}

export function excludePortalBranch(branches) {
  return branches.filter((b) => b.name?.toLowerCase() !== 'portal');
}

export function safelyParseJson(str, _default) {
  try {
    const parsedObj = JSON.parse(str);
    return parsedObj;
  } catch (e) {
    console.error(e);
    return _default || null;
  }
}

export const convertToPayload = (
  filters,
  filtersData,
  dateFormat = 'YYYY-MM-DD',
) => {
  const Obj = {};
  (filters || []).forEach((field) => {
    Obj[field.name] = {
      value:
        field.fieldType === 'dropdown'
          ? (field?.value1 || []).map((f) => f?.label) //.join(',')
          : field?.fieldType === 'date' && field?.operator !== 'Between'
          ? moment(field?.value1).format(dateFormat)
          : field?.fieldType === 'date' && field?.operator === 'Between'
          ? [
              moment(field?.value1).format(dateFormat),
              moment(field?.value2).format(dateFormat),
            ]
          : field.fieldType === 'numeric' && field?.operator !== 'Between'
          ? Number(field?.value1)
          : field.fieldType === 'numeric' && field?.operator === 'Between'
          ? [Number(field?.value1), Number(field?.value2)]
          : field?.fieldType === 'timeFormat' && field?.operator === 'Between'
          ? [field?.value1, field?.value2]
          : field?.value1,
      type: field?.operator,
      // field: field?.name,
      field: filtersData.find((f) => f.key === field.name)?.label,
    };
  });
  return Obj;
};

// export async function checkForOptionsInSelectInput(testId, listOfLabels) {
//   const selectInput = screen.getByTestId(testId);

//   expect(selectInput).toBeInTheDocument();
//   const selectClickTarget = within(selectInput).getByRole('button');
//   userEvent.click(selectClickTarget);
//   // console.log(testId);
//   const dropdown = await screen.findByRole('listbox', {
//     testId: testId + '-dropdown',
//   });

//   expect(dropdown).toBeInTheDocument();
//   // let isLogged = false;
//   await waitFor(() => {
//     const w = within(dropdown).queryByText('No Options');
//     // if (w && !isLogged) {screen.debug(dropdown, 10000);isLogged=true};
//     expect(w).not.toBeInTheDocument();
//   });

//   const optionElements = await within(dropdown).findAllByRole('listitem');
//   for (let i = 0; i < listOfLabels.length; i++) {
//     expect(optionElements[i]).toHaveTextContent(listOfLabels[i]);
//   }
// }

export function queryParamStringToObject(queryParamString) {
  const paramsObj = new URLSearchParams(queryParamString);
  const queryObject = {};
  for (const [key, value] of paramsObj?.entries()) {
    queryObject[key] = value.split(',');
  }
  return queryObject;
}

export function groupBy(xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}
// smooth scroll for Error
export function smoothScrollForError() {
  setTimeout(() => {
    let selector = document.querySelector('.input-error-msg');
    selector?.scrollIntoView({
      block: 'end',
      behavior: 'smooth',
      inline: 'start',
    });
  }, 0.5);
}

export function base64StringtoFile(base64String, filename) {
  var arr = base64String.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = window.atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {type: mime});
}
